import React from 'react';
import st from './styles.module.scss';
import { Align, TextType } from "@baseTypes/baseType";
import ChartHeader from "@elements/chart/ChartHeader";
import Tx from "@baseTypes/naming";
import FlexLine from "@elements/flexLine/FlexLine";
import { EmptyTextBlock } from "@pages/dashboard/crops/empty";

const Empty = () => {
	return (
		<div className={st['empty']}>
			<FlexLine textType={TextType.Header} align={Align.SpaceBetween} style={{paddingBottom: '20px'}}>
				<ChartHeader>{Tx.VehicleStatuses}</ChartHeader>
				<span className={st['empty__text']}>0 ед.</span>
			</FlexLine>
			<svg width="352" height="278" viewBox="0 0 352 278" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect x="0.5" y="0.5" width="351" height="23" rx="4.5" fill="#EAEAEB" stroke="#EAEAEB"/>
				<rect x="64.5819" y="0.5" width="204.616" height="23" fill="#EAEAEB" stroke="#EAEAEB"/>
				<rect x="64.5819" y="0.5" width="204.616" height="23" fill="#EAEAEB" stroke="#EAEAEB"/>
				<rect x="64.5819" y="0.5" width="149.531" height="23" fill="#EAEAEB" stroke="#EAEAEB"/>
				<rect x="64.5819" y="0.5" width="81.5932" height="23" fill="#EAEAEB" stroke="#EAEAEB"/>
				<rect x="29.6613" y="0.5" width="33.9208" height="23" fill="#EAEAEB" stroke="#EAEAEB"/>
				<path d="M0.5 5C0.5 2.51472 2.51472 0.5 5 0.5H28.6613V23.5H5C2.51471 23.5 0.5 21.4853 0.5 19V5Z"
					  fill="#EAEAEB" stroke="#EAEAEB"/>
				<g clipPath="url(#clip0_11156_6996)">
					<rect y="40" width="111" height="14" rx="7" fill="#EAEAEB"/>
					<rect x="274" y="40" width="78" height="14" rx="7" fill="#EAEAEB"/>
					<circle cx="8" cy="88" r="4.5" fill="#EAEAEB" stroke="#EAEAEB"/>
					<rect x="22" y="82" width="139" height="12.25" rx="6.125" fill="#EAEAEB"/>
					<rect x="297" y="78" width="55" height="12.25" rx="6.125" fill="#EAEAEB"/>
					<circle cx="8" cy="118" r="4.5" fill="#EAEAEB" stroke="#EAEAEB"/>
					<rect x="22" y="112" width="133" height="12.25" rx="6.125" fill="#EAEAEB"/>
					<rect x="289" y="108" width="63" height="12.25" rx="6.125" fill="#EAEAEB"/>
					<circle cx="8" cy="148" r="4.5" fill="#EAEAEB" stroke="#EAEAEB"/>
					<rect x="22" y="142" width="168" height="12.25" rx="6.125" fill="#EAEAEB"/>
					<rect x="282" y="138" width="70" height="12.25" rx="6.125" fill="#EAEAEB"/>
					<circle cx="8" cy="178" r="4.5" fill="#EAEAEB" stroke="#EAEAEB"/>
					<rect x="20" y="172" width="199" height="12.25" rx="6.125" fill="#EAEAEB"/>
					<rect x="281" y="168" width="71" height="12.25" rx="6.125" fill="#EAEAEB"/>
					<circle cx="8" cy="208" r="4.5" fill="#EAEAEB" stroke="#EAEAEB"/>
					<rect x="22" y="202" width="191" height="12.25" rx="6.125" fill="#EAEAEB"/>
					<rect x="288" y="198" width="64" height="12.25" rx="6.125" fill="#EAEAEB"/>
					<circle cx="8" cy="238" r="5" fill="#EAEAEB"/>
					<rect x="22" y="232" width="145" height="12.25" rx="6.125" fill="#EAEAEB"/>
					<rect x="300" y="228" width="52" height="12.25" rx="6.125" fill="#EAEAEB"/>
				</g>
				<defs>
					<clipPath id="clip0_11156_6996">
						<rect width="352" height="238" fill="white" transform="translate(0 40)"/>
					</clipPath>
				</defs>
			</svg>
			<div className={st['empty__blur']}>
				<svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
					<rect width="400" height="400" fill="url(#paint0_linear_11156_6920)"/>
					<defs>
						<linearGradient id="paint0_linear_11156_6920" x1="200" y1="42.6063" x2="200" y2="311.874"
										gradientUnits="userSpaceOnUse">
							<stop offset="0.460045" stopColor="white" stopOpacity="0"/>
							<stop offset="0.831741" stopColor="white" stopOpacity="0.958507"/>
							<stop offset="1" stopColor="white"/>
						</linearGradient>
					</defs>
				</svg>

			</div>
			<EmptyTextBlock subtitle={'Для просмотра выберите другие департамент или организацию'} />
		</div>
	)
}

export default Empty;